import {Component, Input, OnInit} from '@angular/core';
import {CCPXDEVTESTER} from "../complexDevices";

@Component({
  selector: 'app-cpxdev-tester',
  templateUrl: './cpxdev-tester.component.html',
  styleUrls: ['./cpxdev-tester.component.css']
})
export class CPXDEVTESTERComponent implements OnInit {
  @Input() cCPXDEV_TESTER: CCPXDEVTESTER | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
